module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "settings"
  }, [(_vm.user) ? _c('div', {
    staticClass: "userBox"
  }, [_c('v-avatar', {
    attrs: {
      "size": "80",
      "color": "grey lighten-4"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.user.image ||
        'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460__340.png',
      "alt": "avatar"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "user-info"
  }, [_c('h1', {
    staticClass: "user-full-name"
  }, [_vm._v("\n          " + _vm._s(_vm.user.first_name + " " + _vm.user.last_name) + "\n        ")]), _vm._v(" "), _c('h2', {
    staticClass: "user-email"
  }, [_vm._v(_vm._s(_vm.user.email))])])], 1) : _vm._e(), _vm._v(" "), (!_vm.user && !_vm.loading) ? _c('h4', {
    staticClass: "user-title"
  }, [_vm._v("\n      " + _vm._s(_vm.$t("settings.settings.unregistered")) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.user && _vm.user.subscription_active && _vm.payment) ? _c('div', {
    staticClass: "subscribe-expire"
  }, [_c('div', {
    staticClass: "settingText"
  }, [_vm._v("\n        " + _vm._s(_vm.$t("settings.settings.until")) + "\n        " + _vm._s(new Date(_vm.payment.payment_expiration_date).toLocaleDateString()) + "\n      ")]), _vm._v(" "), (_vm.payment.next_payment_date) ? _c('div', {
    staticClass: "settingText"
  }, [_vm._v("\n        " + _vm._s(_vm.$t("settings.settings.update")) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.cancel) ? _c('div', {
    staticClass: "settingText"
  }) : _vm._e()]) : (_vm.user) ? _c('div', {
    staticClass: "userBox"
  }, [_c('button', {
    staticClass: "settingBtn",
    on: {
      "click": _vm.goPay
    }
  }, [_c('inline-svg', {
    staticClass: "googleIcon",
    attrs: {
      "src": require('../../assets/svg/lock.svg').default
    }
  }), _vm._v("\n        " + _vm._s(_vm.$t("settings.settings.full-sub")) + "\n      ")], 1)]) : _c('div', {
    staticClass: "loginBtn"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loader"
  }, [_vm._v("\n        " + _vm._s(_vm.$t("settings.settings.connecting")) + "\n        "), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "display": "flex",
      "justify-content": "center",
      "margin": "8px"
    }
  }, [_c('SlinkyVue')], 1)]) : _c('button', {
    staticClass: "settingBtn",
    on: {
      "click": _vm.login
    }
  }, [_c('inline-svg', {
    staticClass: "googleIcon",
    attrs: {
      "src": require('../../assets/svg/googleicon.svg').default
    }
  }), _vm._v("\n        " + _vm._s(_vm.$t("settings.settings.signup")) + "\n      ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "settings-section settings-toggles"
  }, [_c('h4', {
    staticClass: "settings-title"
  }, [_vm._v(_vm._s(_vm.$t("settings.settings.audio")))]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "right-part"
  }, [_c('inline-svg', {
    staticClass: "sound",
    attrs: {
      "width": "30px",
      "src": require('../../assets/svg/music.svg').default
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("settings.settings.sound")))])], 1), _vm._v(" "), _c('label', {
    staticClass: "switch"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.sounds
    },
    on: {
      "change": _vm.soundChange
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkslider round"
  })])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "right-part"
  }, [_c('inline-svg', {
    staticClass: "sound",
    attrs: {
      "src": require('../../assets/svg/autospeak.svg').default
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("settings.settings.speech")))])], 1), _vm._v(" "), _c('label', {
    staticClass: "switch"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.speach
    },
    on: {
      "change": _vm.speachChange
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkslider round"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "settings-section"
  }, [_c('h4', {
    staticClass: "settings-title"
  }, [_vm._v(_vm._s(_vm.$t("settings.settings.talk")))]), _vm._v(" "), _c('div', {
    staticClass: "whatsapp"
  }, [_c('button', {
    on: {
      "click": _vm.goToWA
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t("settings.settings.whatsapp")))]), _vm._v(" "), _c('inline-svg', {
    staticClass: "whatsapp-svg",
    attrs: {
      "src": require('../../assets/svg/whatsapp-svg.svg').default
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "settings-section q"
  }, [_c('h4', {
    staticClass: "settings-title"
  }, [_vm._v(_vm._s(_vm.$t("settings.settings.qna")))]), _vm._v(" "), _vm._l((_vm.faq), function(qa, idx) {
    return (_vm.faq) ? _c('div', {
      key: idx,
      staticClass: "q-and-a",
      style: ({
        height: _vm.calculateHeight(qa)
      })
    }, [_c('div', {
      staticClass: "qa-q",
      on: {
        "click": function($event) {
          return _vm.pickQa(qa)
        }
      }
    }, [_c('p', [_vm._v(_vm._s(qa.question))]), _vm._v(" "), _c('div', {
      staticClass: "setArrow"
    }, [_c('inline-svg', {
      staticClass: "qaArrow",
      class: {
        downArrow: _vm.pickedQa == qa.question
      },
      attrs: {
        "src": _vm.arrowIconPath.arrowIconNext
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "qa-a",
      style: ({
        display: _vm.calculateDisplay(qa)
      })
    }, [_c('p', [_vm._v(_vm._s(qa.answer.replace(/[\r\n]/gm, " ")))])])]) : _vm._e()
  })], 2), _vm._v(" "), (_vm.user) ? _c('div', {
    staticClass: "logout-section"
  }, [_c('div', {
    staticClass: "logoutBtn",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("settings.settings.signout")) + "\n        "), _c('inline-svg', {
    staticClass: "logout",
    attrs: {
      "src": require('../../assets/svg/logout1.svg').default
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.user && _vm.user.subscription_active && _vm.payment && _vm.payment.next_payment_date) ? _c('div', {
    staticClass: "cancelText",
    on: {
      "click": _vm.goToWACancel
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("settings.settings.cancel")) + "\n    ")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26c4b6ba","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Settings/Settings.vue
// module id = 348
// module chunks = 0 10